import type { ShardSummary } from "../../types/shadow-run";
import { formatNumber } from "../../utils/formatters";
import { StatusDistributionBar } from "../StatusDistributionBar/StatusDistributionBar";
import { MatchRateBadge } from "../MatchRateBadge/MatchRateBadge";
import styles from "./ShardTile.module.css";

export interface ShardTileProps {
  shard: ShardSummary;
}

const STATUS_ACCENT: Record<string, string> = {
  running: "running",
  completed: "completed",
  failed: "failed",
  pending: "pending",
};

export function ShardTile({ shard }: ShardTileProps) {
  const accentClass = STATUS_ACCENT[shard.status] ?? "pending";

  return (
    <div
      className={`${styles.tile} ${styles[accentClass]}`}
      data-testid="shard-tile"
    >
      <div className={styles.header}>
        <span className={styles.shardId} title={shard.shard_id}>
          {shard.shard_id.slice(0, 8)}
        </span>
        <span className={`${styles.statusDot} ${styles[`dot${capitalize(shard.status)}`]}`} />
      </div>
      <span className={styles.packetCount}>
        {formatNumber(shard.processed_packets)} / {formatNumber(shard.total_packets)}
      </span>
      <StatusDistributionBar breakdown={shard.status_breakdown} height={8} />
      <MatchRateBadge rate={shard.match_rate} />
    </div>
  );
}

function capitalize(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1);
}
